import { BaseDto, OrderByValue } from '../../core';
export class FaqListDto extends BaseDto<FaqListDto> {
  subject?: string;
  language: string;
  orderById?: OrderByValue;
}
